const $ = require('jquery');

window.addEventListener('load', function () {
  $('[data-toggle-on]').on('change', (event) => {
    const $this = $(event.target);
    const state = $this.prop('checked');
    const toggle = $this.data('toggle-on');
    $(`.${toggle}`).toggleClass('hidden', !state);
  });
  $('[data-toggle-on]').trigger('change');
});
